import { Card, Col, DatePicker, Row, Select, Typography, Space, Button } from "antd";
import { useEffect, useState } from "react";
import { toast } from "react-toastify";
import "../../../assets/styles/carousel.css";
import Footer from "../../../components/Footer";
import NavBar from "../../../components/NavBar";
import SideBar from "../../../components/SideBar";
import axiosInstance from "../../../variables/api/axiosInstance";
import { LOGGED_USER } from "../../../variables/constants";
import { frenchDateOnly } from "../../../variables/functions";
import {
    generateBonAPayerExcel,
    generateBonAPayerPDF,
    generateDecaissementsExcel,
    generateDecaissementsHonorairesPDF,
    generateDecaissementsPDF,
    generateRatioSP,
    generateSinistresDeclaresExcel,
    generateSinistresDeclaresPDF,
    generateSinistresSurvenusExcel,
    generateSinistresSurvenusPDF
} from "./etatsSinistresFunctions";
import {
    FileTextOutlined,
    CalendarOutlined,
    FilterOutlined,
    EyeOutlined
} from '@ant-design/icons';
import PreviewModal from "./components/PreviewModal";

const { RangePicker } = DatePicker;
const { Title, Text } = Typography;

const dateFormat = "YYYY-MM-DD";

// Palette de couleurs
const colors = {
    primary: '#242166',
    secondary: '#1890ff',
    success: '#52c41a',
    warning: '#faad14',
    danger: '#ff4d4f',
    lightBg: '#f8f9fc',
    cardBg: '#ffffff',
    textPrimary: '#262626',
    textSecondary: '#8c8c8c',
    border: '#e8e8f0'
};

const EtatsSinistres = () => {
    const [branches, setBranches] = useState([]);
    const [selectedCategorie, setSelectedCategorie] = useState("");
    const [selectedBranche, setSelectedBranche] = useState("");
    const [selectedEtat, setSelectedEtat] = useState(1);
    const [pdfPreviewUrl, setPdfPreviewUrl] = useState(null);
    const [pdfSSPreviewUrl, setPdfSSPreviewUrl] = useState(null);
    const [pdfSDPreviewUrl, setPdfSDPreviewUrl] = useState(null);
    const [pdfHPPreviewUrl, setPdfHPPreviewUrl] = useState(null);
    const [pdfSBAPPreviewUrl, setPdfSBAPPreviewUrl] = useState(null);
    const [pdfRSPreviewUrl, setPdfRSPreviewUrl] = useState(null);
    const [loading, setLoading] = useState(false);
    const [date, setDate] = useState();
    const [datas, setDatas] = useState([]);
    const [compagnies, setCompagnies] = useState([]);
    const [agences, setAgences] = useState([]);
    const [selectedCompagnie, setSelectedCompagnie] = useState("");
    const [selectedAgence, setSelectedAgence] = useState("");
    const [branche, setBranche] = useState("TPVM");

    useEffect(() => {
        axiosInstance
            .get(`/api/branche`)
            .then((res) => {
                setBranches(res.data);
            })
            .catch((err) => {
                console.log(err);
            });

        axiosInstance
            // Inclut le Pool en plus des compagnies → permet d'éditer les états des sinistres du Pool.
            .get(`/api/organisme/all/assurances-pool`)
            .then((res) => {
                setCompagnies(res.data);
            })
            .catch((err) => {
                console.log(err);
            });

        axiosInstance
            .get(`/api/agence/dtrf`)
            .then((res) => {
                setAgences(res.data);
            })
            .catch((err) => {
                console.log(err);
            });
    }, []);

    const dateFiltering = (_, dateString) => {
        setDate(dateString);
    }


    const brancheFiltering = (_, br) => {
        setSelectedBranche(br.data);
    }

    const compagnieFiltering = (code, comp) => {
        setSelectedCompagnie(comp.data);
    }

    const agenceFiltering = (code, comp) => {
        setSelectedAgence(comp.data);
    }

    const generateDecaissementsPreview = async () => {
        const { data } = await axiosInstance.get("/api/decaissement/all-payes", {
            params: {
                startDate: date ? date[0] : null,
                endDate: date ? date[1] : null,
                branche: selectedBranche?.codeBranche
            }
        });
        setDatas(data);
        setPdfPreviewUrl(await generateDecaissementsPDF(data, selectedBranche?.codeBranche, date));
    }

    const generateSinistresSurvenusPreview = async () => {
        const { data } = await axiosInstance.get("/api/sinistre/all/survenance", {
            params: {
                startDate: date ? date[0] : null,
                endDate: date ? date[1] : null,
                branche: selectedBranche?.codeBranche,
                etat: selectedEtat
            }
        });
        setDatas(data);
        setPdfSSPreviewUrl(await generateSinistresSurvenusPDF(data, selectedBranche?.codeBranche, date));
    }

    const generateSinistresDeclaresPreview = async () => {
        const { data } = await axiosInstance.get("/api/sinistre/all", {
            params: {
                startDate: date ? date[0] : null,
                endDate: date ? date[1] : null,
                branche: selectedBranche?.codeBranche,
                etat: selectedEtat
            }
        });
        setDatas(data);
        setPdfSDPreviewUrl(await generateSinistresDeclaresPDF(data, selectedBranche?.codeBranche, date));
    }

    const generateHonorairesPreview = async () => {
        const { data } = await axiosInstance.get("/api/decaissement/all-honoraires-payes", {
            params: {
                startDate: date ? date[0] : null,
                endDate: date ? date[1] : null,
                branche: selectedBranche?.codeBranche
            }
        });
        setDatas(data);
        setPdfHPPreviewUrl(await generateDecaissementsHonorairesPDF(data, selectedBranche?.codeBranche, date));
    }

    const generateSinistresBonAPayerPreview = async () => {
        const { data } = await axiosInstance.get("/api/decaissement/sinistres-bons-a-payer", {
            params: {
                startDate: date ? date[0] : null,
                endDate: date ? date[1] : null,
                branche: selectedBranche?.codeBranche
            }
        });
        setDatas(data);
        setPdfSBAPPreviewUrl(await generateBonAPayerPDF(data, selectedBranche?.codeBranche, date));
    }

    const generateRatioSPPreview = async () => {
        const { data } = await axiosInstance.get("/api/stats/ratio-sp", {
            params: {
                startDate: date ? date[0] : null,
                endDate: date ? date[1] : null,
            }
        });
        setDatas(data);
        setPdfRSPreviewUrl(await generateRatioSP(data, date));
    }

    // Style pour les cartes de filtre
    const filterCardStyle = {
        borderRadius: '12px',
        border: `1px solid ${colors.border}`,
        boxShadow: '0 2px 8px rgba(36, 33, 102, 0.08)',
        height: '100%',
        background: colors.cardBg
    };

    // Style pour les cartes d'état
    const stateCardStyle = {
        borderRadius: '16px',
        border: `1px solid ${colors.border}`,
        boxShadow: '0 4px 12px rgba(36, 33, 102, 0.1)',
        height: '100%',
        transition: 'all 0.3s ease',
        background: colors.cardBg,
        overflow: 'hidden'
    };

    const cardHeaderStyle = {
        background: `linear-gradient(135deg, ${colors.primary} 0%, ${colors.secondary} 100%)`,
        borderBottom: 'none',
        padding: '20px 24px',
        minHeight: '80px',
        display: 'flex',
        alignItems: 'center'
    };

    const buttonStyle = {
        height: '44px',
        borderRadius: '8px',
        fontWeight: '600',
        fontSize: '15px',
        background: `${colors.primary}`,
        border: 'none',
        boxShadow: '0 4px 8px rgba(82, 196, 26, 0.25)',
        transition: 'all 0.3s ease'
    };

    return (
        <div className="layout-wrapper layout-content-navbar">
            <div className="layout-container">
                <SideBar />

                <div className="layout-page">
                    <NavBar />

                    <div className="content-wrapper" style={{ background: colors.lightBg }}>
                        <div className="container-xxl flex-grow-1 container-p-y">
                            {/* En-tête */}
                            <Card
                                style={{
                                    marginBottom: '22px',
                                    borderRadius: '16px',
                                    border: 'none',
                                    background: `linear-gradient(135deg, ${colors.primary} 0%, ${colors.secondary} 100%)`,
                                    boxShadow: '0 8px 24px rgba(36, 33, 102, 0.15)'
                                }}
                                bodyStyle={{ padding: '22px' }}
                            >
                                <Space direction="vertical" size={4}>
                                    <Title level={2} style={{ margin: 0, color: '#fff' }}>
                                        <FileTextOutlined style={{ marginRight: '12px' }} />
                                        États des Sinistres
                                    </Title>
                                    <Text style={{ fontSize: '16px', color: 'rgba(255,255,255,0.85)' }}>
                                        Générez et consultez vos rapports de sinistres
                                    </Text>
                                </Space>
                            </Card>

                            {/* Filtres */}
                            <Row gutter={[20, 20]} style={{ marginBottom: '32px' }}>
                                <Col xs={24} sm={12} lg={6}>
                                    <Card style={filterCardStyle} bodyStyle={{ padding: '20px' }}>
                                        <Space direction="vertical" size={12} style={{ width: '100%' }}>
                                            <Space>
                                                <CalendarOutlined style={{ fontSize: '18px', color: colors.primary }} />
                                                <Text strong style={{ color: colors.textPrimary, fontSize: '15px' }}>
                                                    Période
                                                </Text>
                                            </Space>
                                            <RangePicker
                                                format={dateFormat}
                                                onChange={dateFiltering}
                                                placeholder={['Date début', 'Date fin']}
                                                style={{
                                                    width: '100%',
                                                    height: '40px',
                                                    borderRadius: '8px'
                                                }}
                                            />
                                        </Space>
                                    </Card>
                                </Col>

                                <Col xs={24} sm={12} lg={6}>
                                    <Card style={filterCardStyle} bodyStyle={{ padding: '20px' }}>
                                        <Space direction="vertical" size={12} style={{ width: '100%' }}>
                                            <Space>
                                                <FilterOutlined style={{ fontSize: '18px', color: colors.primary }} />
                                                <Text strong style={{ color: colors.textPrimary, fontSize: '15px' }}>
                                                    Branche
                                                </Text>
                                            </Space>
                                            <Select
                                                placeholder="Sélectionner..."
                                                style={{ width: '100%' }}
                                                onChange={brancheFiltering}
                                                options={branches.map((branche) => ({
                                                    value: branche.codeBranche,
                                                    label: branche.nom,
                                                    data: branche
                                                }))}
                                            />
                                        </Space>
                                    </Card>
                                </Col>

                                {LOGGED_USER?.profil?.organisme?.typeOrganisme === "POOL" && branche === "TPVM" && (
                                    <Col xs={24} sm={12} lg={6}>
                                        <Card style={filterCardStyle} bodyStyle={{ padding: '20px' }}>
                                            <Space direction="vertical" size={12} style={{ width: '100%' }}>
                                                <Space>
                                                    <FilterOutlined style={{ fontSize: '18px', color: colors.primary }} />
                                                    <Text strong style={{ color: colors.textPrimary, fontSize: '15px' }}>
                                                        Compagnie
                                                    </Text>
                                                </Space>
                                                <Select
                                                    placeholder="Sélectionner..."
                                                    style={{ width: '100%' }}
                                                    onChange={compagnieFiltering}
                                                    options={compagnies.map((com) => ({
                                                        value: com.code,
                                                        label: com.raisonSociale,
                                                        data: com
                                                    }))}
                                                />
                                            </Space>
                                        </Card>
                                    </Col>
                                )}

                                {LOGGED_USER?.profil?.organisme?.typeOrganisme === "POOL" && branche === "GUM" && (
                                    <Col xs={24} sm={12} lg={6}>
                                        <Card style={filterCardStyle} bodyStyle={{ padding: '20px' }}>
                                            <Space direction="vertical" size={12} style={{ width: '100%' }}>
                                                <Space>
                                                    <FilterOutlined style={{ fontSize: '18px', color: colors.primary }} />
                                                    <Text strong style={{ color: colors.textPrimary, fontSize: '15px' }}>
                                                        Bureau DTRF
                                                    </Text>
                                                </Space>
                                                <Select
                                                    placeholder="Sélectionner..."
                                                    style={{ width: '100%' }}
                                                    onChange={agenceFiltering}
                                                    options={agences.map((ag) => ({
                                                        value: ag.codeAgence,
                                                        label: ag.nom,
                                                        data: ag
                                                    }))}
                                                />
                                            </Space>
                                        </Card>
                                    </Col>
                                )}

                                <Col xs={24} sm={12} lg={6}>
                                    <Card style={filterCardStyle} bodyStyle={{ padding: '20px' }}>
                                        <Space direction="vertical" size={12} style={{ width: '100%' }}>
                                            <Space>
                                                <FilterOutlined style={{ fontSize: '18px', color: colors.primary }} />
                                                <Text strong style={{ color: colors.textPrimary, fontSize: '15px' }}>
                                                    État du sinistre
                                                </Text>
                                            </Space>
                                            <Select
                                                placeholder="Sélectionner..."
                                                style={{ width: '100%' }}
                                                value={selectedEtat}
                                                onChange={setSelectedEtat}
                                                options={[
                                                    { label: "En cours", value: 1 },
                                                    { label: "Terminé", value: 2 },
                                                    { label: "Sans suite", value: 3 },
                                                    { label: "Réouverts", value: 5 },
                                                    { label: "Tardifs", value: 6 },
                                                    { label: "Tous les sinistres", value: 4 }
                                                ]}
                                            />
                                        </Space>
                                    </Card>
                                </Col>
                            </Row>

                            {/* Cartes d'états */}
                            <Row gutter={[24, 24]}>
                                {/* Sinistres déclarés */}
                                <Col xs={24} md={12} xl={8}>
                                    <Card
                                        style={stateCardStyle}
                                        styles={{
                                            header: cardHeaderStyle,
                                            body: { padding: '24px' }
                                        }}
                                        title={
                                            <Text strong style={{ color: '#fff', fontSize: '16px' }}>
                                                Sinistres Déclarés
                                            </Text>
                                        }
                                    >
                                        <Space direction="vertical" size={16} style={{ width: '100%' }}>
                                            <Text style={{ color: colors.textSecondary, fontSize: '14px', lineHeight: '1.6' }}>
                                                États des sinistres déclarés sur une période, suivant une branche donnée
                                            </Text>
                                            <Button
                                                type="primary"
                                                icon={<EyeOutlined />}
                                                block
                                                size="large"
                                                style={buttonStyle}
                                                onClick={() => {
                                                    if (!date) return toast.error("Veuillez sélectionner une période");
                                                    generateSinistresDeclaresPreview();
                                                }}
                                                loading={loading}
                                            >
                                                Visualiser
                                            </Button>
                                        </Space>
                                    </Card>
                                </Col>
                                {/* Sinistres survenus */}
                                <Col xs={24} md={12} xl={8}>
                                    <Card
                                        style={stateCardStyle}
                                        styles={{
                                            header: cardHeaderStyle,
                                            body: { padding: '24px' }
                                        }}
                                        title={
                                            <Text strong style={{ color: '#fff', fontSize: '16px' }}>
                                                Sinistres Survenus
                                            </Text>
                                        }
                                    >
                                        <Space direction="vertical" size={16} style={{ width: '100%' }}>
                                            <Text style={{ color: colors.textSecondary, fontSize: '14px', lineHeight: '1.6' }}>
                                                États des sinistres survenus sur une période, suivant une branche donnée
                                            </Text>
                                            <Button
                                                type="primary"
                                                icon={<EyeOutlined />}
                                                block
                                                size="large"
                                                style={buttonStyle}
                                                onClick={() => {
                                                    if (!date) return toast.error("Veuillez sélectionner une période");
                                                    generateSinistresSurvenusPreview();
                                                }}
                                                loading={loading}
                                            >
                                                Visualiser
                                            </Button>
                                        </Space>
                                    </Card>
                                </Col>
                                {/* Sinistres payés */}
                                <Col xs={24} md={12} xl={8}>
                                    <Card
                                        style={stateCardStyle}
                                        styles={{
                                            header: cardHeaderStyle,
                                            body: { padding: '24px' }
                                        }}
                                        title={
                                            <Text strong style={{ color: '#fff', fontSize: '16px' }}>
                                                Sinistres Payés
                                            </Text>
                                        }
                                    >
                                        <Space direction="vertical" size={16} style={{ width: '100%' }}>
                                            <Text style={{ color: colors.textSecondary, fontSize: '14px', lineHeight: '1.6' }}>
                                                États des sinistres payés sur une période, suivant une branche donnée
                                            </Text>
                                            <Button
                                                type="primary"
                                                icon={<EyeOutlined />}
                                                block
                                                size="large"
                                                style={buttonStyle}
                                                onClick={() => {
                                                    if (!date) return toast.error("Veuillez sélectionner une période");
                                                    generateDecaissementsPreview();
                                                }}
                                                loading={loading}
                                            >
                                                Visualiser
                                            </Button>
                                        </Space>
                                    </Card>
                                </Col>
                                {/* Honoraires payés */}
                                <Col xs={24} md={12} xl={8}>
                                    <Card
                                        style={stateCardStyle}
                                        styles={{
                                            header: cardHeaderStyle,
                                            body: { padding: '24px' }
                                        }}
                                        title={
                                            <Text strong style={{ color: '#fff', fontSize: '16px' }}>
                                                Honoraires Payés
                                            </Text>
                                        }
                                    >
                                        <Space direction="vertical" size={16} style={{ width: '100%' }}>
                                            <Text style={{ color: colors.textSecondary, fontSize: '14px', lineHeight: '1.6' }}>
                                                États des retenues sur honoraires payés sur une période, suivant une branche donnée
                                            </Text>
                                            <Button
                                                type="primary"
                                                icon={<EyeOutlined />}
                                                block
                                                size="large"
                                                style={buttonStyle}
                                                onClick={() => {
                                                    if (!date) return toast.error("Veuillez sélectionner une période");
                                                    generateHonorairesPreview();
                                                }}
                                                loading={loading}
                                            >
                                                Visualiser
                                            </Button>
                                        </Space>
                                    </Card>
                                </Col>
                                {/* Ratio S/P */}
                                <Col xs={24} md={12} xl={8}>
                                    <Card
                                        style={stateCardStyle}
                                        styles={{
                                            header: cardHeaderStyle,
                                            body: { padding: '24px' }
                                        }}
                                        title={
                                            <Text strong style={{ color: '#fff', fontSize: '16px' }}>
                                                Ratio S/P
                                            </Text>
                                        }
                                    >
                                        <Space direction="vertical" size={16} style={{ width: '100%' }}>
                                            <Text style={{ color: colors.textSecondary, fontSize: '14px', lineHeight: '1.6' }}>
                                                État du ratio sinistres sur primes sur une période donnée
                                            </Text>
                                            <Button
                                                type="primary"
                                                icon={<EyeOutlined />}
                                                block
                                                size="large"
                                                style={buttonStyle}
                                                onClick={() => {
                                                    if (!date) return toast.error("Veuillez sélectionner une période");
                                                    generateRatioSPPreview();
                                                }}
                                                loading={loading}
                                            >
                                                Visualiser
                                            </Button>
                                        </Space>
                                    </Card>
                                </Col>
                                {/* Bon à payer */}
                                <Col xs={24} md={12} xl={8}>
                                    <Card
                                        style={stateCardStyle}
                                        styles={{
                                            header: cardHeaderStyle,
                                            body: { padding: '24px' }
                                        }}
                                        title={
                                            <Text strong style={{ color: '#fff', fontSize: '16px' }}>
                                                Etat des sinistres bon à payer
                                            </Text>
                                        }
                                    >
                                        <Space direction="vertical" size={16} style={{ width: '100%' }}>
                                            <Text style={{ color: colors.textSecondary, fontSize: '14px', lineHeight: '1.6' }}>
                                                État des sinistres bon à payer sur une période donnée
                                            </Text>
                                            <Button
                                                type="primary"
                                                icon={<EyeOutlined />}
                                                block
                                                size="large"
                                                style={buttonStyle}
                                                onClick={() => {
                                                    if (!date) return toast.error("Veuillez sélectionner une période");
                                                    generateSinistresBonAPayerPreview();
                                                }}
                                                loading={loading}
                                            >
                                                Visualiser
                                            </Button>
                                        </Space>
                                    </Card>
                                </Col>
                            </Row>

                            {/* Modales de prévisualisation */}
                            <PreviewModal
                                visible={!!pdfPreviewUrl}
                                onClose={() => setPdfPreviewUrl(null)}
                                url={pdfPreviewUrl}
                                title="Prévisualisation - Sinistres Payés"
                                downloadName={`Etats des Sinistres du ${date ? frenchDateOnly(date[0]) : ''} au ${date ? frenchDateOnly(date[1]) : ''} _ ${(new Date()).toLocaleString("fr-FR", {
                                    day: "2-digit",
                                    month: "2-digit",
                                    year: "numeric",
                                    hour: "2-digit",
                                    minute: "2-digit"
                                })}.pdf`}
                                excelFunction={() => generateDecaissementsExcel(datas, selectedCategorie?.codeCategorie, date)}
                            />

                            <PreviewModal
                                visible={!!pdfSSPreviewUrl}
                                onClose={() => setPdfSSPreviewUrl(null)}
                                url={pdfSSPreviewUrl}
                                title="Prévisualisation - Sinistres Survenus"
                                downloadName={`Etats des Sinistres survenus du ${date ? frenchDateOnly(date[0]) : ''} au ${date ? frenchDateOnly(date[1]) : ''} _ ${(new Date()).toLocaleString("fr-FR", {
                                    day: "2-digit",
                                    month: "2-digit",
                                    year: "numeric",
                                    hour: "2-digit",
                                    minute: "2-digit"
                                })}.pdf`}
                                excelFunction={() => generateSinistresSurvenusExcel(datas, date)}
                            />

                            <PreviewModal
                                visible={!!pdfSDPreviewUrl}
                                onClose={() => setPdfSDPreviewUrl(null)}
                                url={pdfSDPreviewUrl}
                                title="Prévisualisation - Sinistres Déclarés"
                                downloadName={`Etats des Sinistres déclarés du ${date ? frenchDateOnly(date[0]) : ''} au ${date ? frenchDateOnly(date[1]) : ''} _ ${(new Date()).toLocaleString("fr-FR", {
                                    day: "2-digit",
                                    month: "2-digit",
                                    year: "numeric",
                                    hour: "2-digit",
                                    minute: "2-digit"
                                })}.pdf`}
                                excelFunction={() => generateSinistresDeclaresExcel(datas, date)}
                            />

                            <PreviewModal
                                visible={!!pdfHPPreviewUrl}
                                onClose={() => setPdfHPPreviewUrl(null)}
                                url={pdfHPPreviewUrl}
                                title="Prévisualisation - Honoraires Payés"
                                downloadName={`Etats des retenues sur honoraires payés du ${date ? frenchDateOnly(date[0]) : ''} au ${date ? frenchDateOnly(date[1]) : ''} _ ${(new Date()).toLocaleString("fr-FR", {
                                    day: "2-digit",
                                    month: "2-digit",
                                    year: "numeric",
                                    hour: "2-digit",
                                    minute: "2-digit"
                                })}.pdf`}
                                excelFunction={() => generateSinistresDeclaresExcel(datas, date)}
                            />

                            <PreviewModal
                                visible={!!pdfSBAPPreviewUrl}
                                onClose={() => setPdfSBAPPreviewUrl(null)}
                                url={pdfSBAPPreviewUrl}
                                title="Prévisualisation - Sinistres Bons à Payer"
                                downloadName={`Etats des sinistres bons à payer du ${date ? frenchDateOnly(date[0]) : ''} au ${date ? frenchDateOnly(date[1]) : ''} _ ${(new Date()).toLocaleString("fr-FR", {
                                    day: "2-digit",
                                    month: "2-digit",
                                    year: "numeric",
                                    hour: "2-digit",
                                    minute: "2-digit"
                                })}.pdf`}
                                excelFunction={() => generateBonAPayerExcel(datas, selectedBranche?.codeBranche, date)}
                            />

                            <PreviewModal
                                visible={!!pdfRSPreviewUrl}
                                onClose={() => setPdfRSPreviewUrl(null)}
                                url={pdfRSPreviewUrl}
                                title="Prévisualisation - Ratio S/P"
                                downloadName={`Etat Ratio S/P sur la période du ${date ? frenchDateOnly(date[0]) : ''} au ${date ? frenchDateOnly(date[1]) : ''} _ ${(new Date()).toLocaleString("fr-FR", {
                                    day: "2-digit",
                                    month: "2-digit",
                                    year: "numeric",
                                    hour: "2-digit",
                                    minute: "2-digit"
                                })}.pdf`}
                                excelFunction={null}
                            />
                        </div>

                        <Footer />

                        <div className="content-backdrop fade"></div>
                    </div>
                </div>
            </div>

            <div className="layout-overlay layout-menu-toggle"></div>
            <div className="drag-target"></div>
        </div>
    );
};

export default EtatsSinistres;